import { useMutation } from '@tanstack/react-query';
import type { UpdateBankingDetailsRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { linkBankAccount } from '../api/linkBankAccount.js';

export interface LinkBankAccountVariables {
  data: UpdateBankingDetailsRequestT;
}

export function useLinkBankAccountMutation() {
  return useMutation({
    mutationKey: ['clinician-bank-link', 'link-bank-account'],
    mutationFn: async ({ data }: LinkBankAccountVariables) => {
      return await linkBankAccount(data);
    },
  });
}
